<template>
	<div class="flex m-auto justify-between mb-1 items-start">
		<div class="flex-grow flex flex-col items-start">
			<div :class="style.title">
				<span v-if="store.cart?.coupon?.code">Coupon ({{ store?.cart?.coupon?.code }})</span>
				<span v-else>Coupon:</span>
			</div>
			<div v-if="store.cart?.coupon?.code">
				<div class="text-xs">{{ checkout.couponDiscountSummary }}</div>
				<button @click="removeCoupon" class="underline text-ihh-dark-salmon hover:text-ihh-salmon" :class="style.remove">Remove</button>
			</div>
		</div>
		<!-- <div class="flex w-full border-b border-dotted flex-grow m-auto items-center border-ihh-gray mx-4"></div> -->
		<div>
			<button @click="addingCoupon = !addingCoupon" :class="couponClasses">
				{{ couponText }}
			</button>
		</div>
	</div>

	<div v-if="addingCoupon" class="flex justify-between items-center mt-4 space-x-2">
		<div class="w-full">
			<input type="text" v-model="couponCode" @input="toUpperCase" class="w-full border border-ihh-gray rounded-lg px-4 py-1" placeholder="Enter your coupon code" />
		</div>
		<div>
			<button @click="addCoupon" class="bg-ihh-dark-salmon px-4 py-1 text-sm font-ihh-bold text-ihh-midnight-gray rounded-xl w-32">Apply</button>
		</div>
	</div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import helpers from '../../helpers/checkout.js'
import { useCheckoutStore } from '../../stores/store.js'

export default {
	name: 'Coupon',
	inject: ['store'],
	props: {
		style: {
			type: Object,
			default: {
				title: 'font-bold text-ihh-midnight-gray',
				remove: 'text-sm',
			},
		},
	},
	data() {
		return {
			addingCoupon: false,
			couponCode: '',
			loading: false,
			checkout: useCheckoutStore(),
		}
	},

	mounted() {
		this.couponCode = this.store.cart?.coupon?.code || ''
	},

	methods: {
		toUpperCase() {
			// Force coupon code to uppercase
			this.couponCode = this.couponCode.toUpperCase()
		},
		async addCoupon() {
			console.log('add coupon clicked')

			this.checkout.updateShowOverlay(true)

			const url = `${this.store.api}/controllers/bigCommerce/checkout/carts/coupons`
			const response = await axios.post(url, { code: this.couponCode, cartId: this.store.cart.bcId })

			console.log('Add coupon response: ', response?.data)

			if (!response?.data?.success) {
				this.checkout.updateShowOverlay(false)
				// if response.data.message is an empty object, show the fallback
				let errorText = response?.data?.message?.length ? response?.data?.message : 'The provided code does not match any valid coupon.'
				return Swal.fire({
					icon: 'error',
					title: 'Coupon Error',
					text: errorText,
				})
			}

			let coupon = response?.data?.coupon
			let checkout = response?.data?.checkout

			this.store.cart.coupon = coupon
			this.store.cart.couponDiscount = checkout?.coupons[0]?.discounted_amount || 0

			console.log('couponDiscount: ', this.store.cart.couponDiscount)

			helpers.updateCheckoutTotals(checkout)

			// The server cart stores the coupon code; it re-prices the cart and answers with the totals.
			await this.store.saveCart?.()

			this.checkout.updateShowOverlay(false)
			this.addingCoupon = false
		},
		async removeCoupon() {
			console.log('remove coupon clicked')

			this.checkout.updateShowOverlay(true)

			if (!this.store.cart?.coupon?.code) {
				await helpers.fetchCheckoutTotals()
				this.store.cart.coupon = { code: '' }
				this.store.cart.couponDiscount = 0
				this.couponCode = ''
				this.checkout.updateShowOverlay(false)
				return
			}

			const url = `${this.store.api}/controllers/bigCommerce/checkout/carts/coupons/delete`
			const response = await axios.post(url, { coupon: this.store?.cart?.coupon?.code, cartId: this.store.cart?.bcId })

			if (!response?.data?.success) {
				this.checkout.updateShowOverlay(false)
				return Swal.fire({
					icon: 'error',
					title: 'Error Removing Coupon',
					text: response?.data?.message || 'Unknown error encountered while removing coupon.',
				})
			}
			this.store.cart.coupon = { code: '' }
			this.store.cart.couponDiscount = 0
			this.couponCode = ''

			helpers.updateCheckoutTotals(response?.data?.checkout)
			await this.store.saveCart?.()

			this.checkout.updateShowOverlay(false)
		},
	},

	computed: {
		couponText() {
			if (this.store.cart?.coupon?.code) {
				if (this.checkout.couponDiscount) {
					return `-${this.checkout.couponDiscount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`
				} else {
					return `${this.checkout.couponDiscount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`
				}
			} else {
				if (this.addingCoupon) return 'Cancel'
				return 'Add Coupon'
			}
		},
		couponClasses() {
			const baseClasses = 'w-24 text-right font-normal'
			if (this.store?.cart?.coupon?.code) return baseClasses
			if (this.addingCoupon) return 'underline cursor-pointer italic text-ihh-dark-salmon' + ' ' + baseClasses
			return 'underline cursor-pointer text-ihh-dark-salmon' + ' ' + baseClasses
		},
	},
}
</script>

<style scoped></style>
